import { Inbox, CalendarClock, FilePen, AlertTriangle, UserRound, Users, PenLine, CloudOff, Ban, CheckCircle2, Archive } from "lucide-react";

export const NAV_COLORS = {
  "/": "#4F46E5", "/schedule": "#059669", "/templates": "#0284C7", "/imports": "#D97706", "/reports": "#C026D3", "/admin": "#E11D48", "/enterprise": "#334155",
};

export const FOLDER_COLORS = {
  my_work: "#4F46E5", today: "#0284C7", drafts: "#64748B", needs_review: "#D97706", awaiting_patient: "#2563EB",
  awaiting_representative: "#9333EA", signed: "#059669", export_issues: "#EA580C", exceptions: "#E11D48", completed: "#0D9488", archived: "#64748B",
};

export const FOLDERS = [
  { key: "my_work", label: "My Work", icon: Inbox },
  { key: "today", label: "Due", icon: CalendarClock },
  { key: "drafts", label: "Drafts", icon: FilePen },
  { key: "needs_review", label: "Needs Review", icon: AlertTriangle },
  { key: "awaiting_patient", label: "Awaiting Patient", icon: UserRound },
  { key: "awaiting_representative", label: "Awaiting Representative", icon: Users },
  { key: "signed", label: "Signed", icon: PenLine },
  { key: "export_issues", label: "Export Issues", icon: CloudOff },
  { key: "exceptions", label: "Declined & Exceptions", icon: Ban },
  { key: "completed", label: "Completed", icon: CheckCircle2 },
  { key: "archived", label: "Archived", icon: Archive },
];

export const STATUS = {
  draft: ["Draft", "bg-slate-100 text-slate-700 border-slate-300"],
  ready: ["Ready to sign", "bg-sky-100 text-sky-900 border-sky-300"],
  in_signing: ["Signing on device", "bg-indigo-100 text-indigo-900 border-indigo-300"],
  awaiting_patient: ["Remote link sent", "bg-blue-100 text-blue-900 border-blue-300"],
  needs_review: ["Needs review", "bg-amber-100 text-amber-900 border-amber-300"],
  awaiting_witness: ["Awaiting witness", "bg-purple-100 text-purple-900 border-purple-300"],
  awaiting_provider: ["Awaiting provider verification", "bg-fuchsia-100 text-fuchsia-900 border-fuchsia-300"],
  signed: ["Signed - not filed", "bg-emerald-100 text-emerald-900 border-emerald-300"],
  completed: ["Completed", "bg-teal-100 text-teal-900 border-teal-300"],
  declined: ["Declined / exception", "bg-rose-100 text-rose-900 border-rose-300"],
  voided: ["Voided", "bg-slate-200 text-slate-800 border-slate-400"],
  expired: ["Expired", "bg-amber-200 text-amber-900 border-amber-400"],
  evidence_review: ["Evidence review", "bg-orange-100 text-orange-900 border-orange-300"],
  finalization_pending: ["Finalizing", "bg-yellow-100 text-yellow-900 border-yellow-300"],
  finalization_failed: ["Finalization failed", "bg-red-100 text-red-900 border-red-300"],
};

export const EXPORT = {
  none: "Not exported", ready: "Ready to export", blocked_mapping: "Blocked: pending EHR mapping", failed: "Export failed",
  delivered: "Delivered - awaiting chart acknowledgment", acknowledged: "Filed in chart (acknowledged)",
};

export const ROLE_LABEL = {
  practice_admin: "Organization administrator", coordinator: "Operations coordinator", provider: "Provider / therapist",
  regional_director: "Regional director", template_approver: "Template approver",
};

let DF = "MM/DD/YYYY";
export const DATE_FORMATS = ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY-MM-DD"];
export const byName = (a, b) => (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" });
export const setDateFormat = (f) => { DF = DATE_FORMATS.includes(f) ? f : "MM/DD/YYYY"; };
export const dateFormat = () => DF;
const ymdParts = (s) => [s.slice(0, 4), s.slice(5, 7), s.slice(8, 10)];
const fmtParts = ([y, m, d]) => (DF === "DD/MM/YYYY" ? `${d}/${m}/${y}` : DF === "YYYY-MM-DD" ? `${y}-${m}-${d}` : `${m}/${d}/${y}`);
export const fmtDate = (s) => {
  if (!s || typeof s !== "string" || s[4] !== "-") return s || "";
  if (s.length > 10) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return fmtParts([String(d.getFullYear()), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")]);
  }
  return fmtParts(ymdParts(s));
};
export const fmt = (s) => (s ? `${fmtDate(s)} ${new Date(s).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}` : "-");
